export default {
	title: "Users",
	email: "Email",
	createdAt: "Created at",
	totalUsers: "Total users",
	adminUsers: "Administrators",
	confirmRemove: "Confirm Removal",
	confirmRemoveMessage: "Are you sure you want to remove {name} from the temple?",
	displayName: "Name",
	inviteUser: "Invite User",
	memberUsers: "Members",
	ownerUsers: "Owners",
	removeError: "Error removing user",
	removeSuccess: "User removed successfully",
	ritualFunction: "Ritual Function",
	role: "Role",
	roleChangeError: "Error changing role",
	roleChangeSuccess: "Role updated successfully",
};
